"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLettersFromIndex = void 0;
/**
 * Generates letter(s) when provided an index
 *
 * @name generateId
 * @param {Number} index to start new ID value with
 */
const getLettersFromIndex = index => {
  // Ensure the index is within the alphabet range
  if (index < 0) {
    return null;
  }

  /* Calculate the current character's charCode based on the alphabet
   65 is the ASCII value of "A", so we add (index % 26) to get a letter from A to Z
   Module ensures the values wrap around after 25, so for index 26, it resets back to "A" */
  const charCode = 65 + index % 26;

  // Converts the charCode to a letter and converts to lowercase.
  const currentChar = String.fromCharCode(charCode).toLowerCase();

  /* Recursive case: if the index > 25, get the prefix letter
  Math.floor(index/26) tell us how many times we've completed a full alphabet cycle.
  Subtracting 1 ensures proper handling of zero-based indexing */
  if (index > 25) {
    // recursive call to get the letter(s) for the prefix and append the currentChar
    return getLettersFromIndex(Math.floor(index / 26) - 1) + currentChar;
  }
  // base case: if is index in range of 0 to 25, return the current letter.
  return currentChar;
};
exports.getLettersFromIndex = getLettersFromIndex;